import React from "react";
import { Box, Container, Grid, Link, Stack, Typography, Divider } from "@mui/material";
import { usfuel } from "../../../assets";
import { footerLinks } from "../../../constants";

const Footer = () => {
  const filteredFooterLinks = footerLinks.filter(
    (group) => group.title.toLowerCase() !== "partners"
  );

  return (
    <Box component="footer" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          {/* Brand */}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Box
                component="img"
                src={usfuel}
                alt="US Fuel Pro"
                sx={{ width: 266, height: 72, objectFit: "contain" }}
              />
              <Typography
                variant="body1"
                sx={{ color: "rgba(226,232,240,0.8)", maxWidth: 320 }}
              >
                Manage your station like a pro.
              </Typography>
            </Stack>
          </Grid>

          {/* Link groups */}
          <Grid item xs={12} md={8}>
            <Grid container spacing={4}>
              {filteredFooterLinks.map((group) => (
                <Grid item xs={6} sm={4} key={group.title}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: "#fff", mb: 2 }}
                  >
                    {group.title}
                  </Typography>

                  <Stack spacing={1.25}>
                    {group.links.map((l) => (
                      <Link
                        key={l.name}
                        href={l.link || "#"}
                        underline="none"
                        sx={{
                          color: "rgba(226,232,240,0.75)",
                          "&:hover": { color: "primary.main" },
                          fontSize: "0.95rem",
                          width: "fit-content",
                        }}
                      >
                        {l.name}
                      </Link>
                    ))}
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 5, borderColor: "rgba(148,163,184,0.25)" }} />

        <Typography
          variant="body2"
          sx={{ color: "rgba(226,232,240,0.6)", textAlign: "center" }}
        >
          {new Date().getFullYear()} US Fuel Pro. All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
